(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var announcer = document.getElementById('BtAnnouncer');
  var raf = 0;
  function announce(text){
    if(!announcer) return;
    cancelAnimationFrame(raf);
    announcer.textContent = '';
    raf = requestAnimationFrame(function(){ announcer.textContent = text; });
  }

  /* header: hide on scroll down, show on scroll up */
  var header = document.querySelector('[data-bt-header]');
  if(header){
    var lastY = window.scrollY, ticking = false;
    window.addEventListener('scroll', function(){
      if(ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        var y = window.scrollY;
        var menuOpen = document.querySelector('.bt-menu[open]');
        if(y > 120 && y > lastY && !menuOpen && !header.contains(document.activeElement)){ header.classList.add('is-hidden'); }
        else if(y < lastY - 4 || y <= 120){ header.classList.remove('is-hidden'); }
        lastY = y; ticking = false;
      });
    }, {passive:true});
    header.addEventListener('focusin', function(){ header.classList.remove('is-hidden'); });
  }

  /* mobile menu dialog */
  var menu = document.querySelector('[data-bt-menu]');
  var opener = null;
  document.querySelectorAll('[data-bt-menu-open]').forEach(function(b){
    b.addEventListener('click', function(){ if(!menu) return; opener = b; menu.showModal(); b.setAttribute('aria-expanded','true'); });
  });
  if(menu){
    menu.querySelectorAll('[data-bt-menu-close]').forEach(function(b){ b.addEventListener('click', function(){ menu.close(); }); });
    menu.addEventListener('click', function(e){ if(e.target === menu) menu.close(); });
    menu.addEventListener('close', function(){ if(opener){ opener.setAttribute('aria-expanded','false'); opener.focus(); } });
  }

  /* stretch: wdth 62 -> 125, photos spread */
  document.querySelectorAll('[data-bt-stretch]').forEach(function(sec){
    var word = sec.querySelector('.bt-stretch__word');
    var row = sec.querySelector('.bt-stretch__row');
    function update(initial){
      if(reduce.matches){ word.style.setProperty('--w', 125); if(row) row.style.setProperty('--gap', 24); return; }
      var r = sec.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1;
      var e = 1 - Math.pow(1 - p, 3);
      word.style.setProperty('--w', (62 + 63 * e).toFixed(1));
      if(row) row.style.setProperty('--gap', (8 + 120 * e).toFixed(0));
    }
    var on = false;
    var io = new IntersectionObserver(function(en){ on = en[0].isIntersecting; if(on) update(); });
    io.observe(sec);
    window.addEventListener('scroll', function(){ if(on) requestAnimationFrame(update); }, {passive:true});
    window.addEventListener('resize', update);
    update();
  });

  /* toast */
  var toast = document.querySelector('[data-bt-toast]');
  var tTimer = 0, tHold = false;
  function hideToast(){
    if(!toast) return;
    toast.classList.remove('is-on');
    setTimeout(function(){ if(!toast.classList.contains('is-on')) toast.hidden = true; }, 160);
  }
  function arm(){ clearTimeout(tTimer); tTimer = setTimeout(function(){ if(!tHold) hideToast(); }, 5000); }
  function showToast(text){
    if(!toast) return;
    toast.querySelector('[data-bt-toast-text]').textContent = text;
    toast.hidden = false;
    requestAnimationFrame(function(){ toast.classList.add('is-on'); });
    arm();
  }
  if(toast){
    toast.addEventListener('mouseenter', function(){ tHold = true; });
    toast.addEventListener('mouseleave', function(){ tHold = false; arm(); });
    toast.addEventListener('focusin', function(){ tHold = true; });
    toast.addEventListener('focusout', function(){ tHold = false; arm(); });
    toast.querySelector('[data-bt-toast-close]').addEventListener('click', hideToast);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !toast.hidden) hideToast(); });
  }

  function setCount(n){
    document.querySelectorAll('[data-bt-count]').forEach(function(c){ c.textContent = n; c.dataset.count = n; });
  }

  /* product */
  document.querySelectorAll('[data-bt-product]').forEach(function(root){
    var data = JSON.parse(root.querySelector('[data-bt-variants]').textContent);
    var form = root.querySelector('form[data-bt-form]');
    var idInput = form.querySelector('input[name="id"]');
    var btns = root.querySelectorAll('[data-bt-add]');
    var priceEls = root.querySelectorAll('[data-bt-price]');
    var errEl = root.querySelector('[data-bt-error]');
    var labels = root.dataset;
    var gal = root.querySelector('.bt-gal');
    var counter = root.querySelector('[data-bt-counter]');
    var fieldsets = root.querySelectorAll('fieldset[data-index]');

    function selected(){
      var out = [];
      fieldsets.forEach(function(fs){ var c = fs.querySelector('input:checked'); out[+fs.dataset.index] = c ? c.value : null; });
      return out;
    }
    function find(opts){
      return data.find(function(v){ return v.options.every(function(o,i){ return opts[i] === null || opts[i] === undefined || o === opts[i]; }); });
    }
    function refreshAvailability(opts){
      fieldsets.forEach(function(fs){
        var idx = +fs.dataset.index;
        fs.querySelectorAll('input').forEach(function(inp){
          var test = opts.slice(); test[idx] = inp.value;
          var ok = data.some(function(v){ return v.available && v.options.every(function(o,i){ return test[i] === null || test[i] === undefined || o === test[i]; }); });
          inp.disabled = !ok;
        });
        var cur = fs.querySelector('[data-bt-current]');
        var c = fs.querySelector('input:checked');
        if(cur) cur.textContent = c ? c.value : '';
      });
    }
    function update(initial){
      var opts = selected();
      refreshAvailability(opts);
      var v = find(opts);
      var complete = opts.every(function(o){ return o !== null && o !== undefined; });
      if(v && complete){
        idInput.value = v.id;
        priceEls.forEach(function(p){ p.innerHTML = v.price_html; });
        btns.forEach(function(b){ b.disabled = !v.available; b.textContent = v.available ? labels.add : labels.soldout; });
        if(v.media && gal && initial !== true){
          var li = gal.querySelector('[data-media="' + v.media + '"]');
          if(li && window.innerWidth < 990){ gal.scrollTo({left: li.offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth'}); }
        }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url.toString());
      } else {
        btns.forEach(function(b){ b.disabled = true; b.textContent = labels.add; });
      }
    }
    fieldsets.forEach(function(fs){ fs.addEventListener("change", function(){ update(false); }); });
    if(fieldsets.length) update(true);

    if(gal && counter){
      var items = gal.querySelectorAll('li');
      gal.addEventListener('scroll', function(){
        var i = Math.round(gal.scrollLeft / gal.clientWidth) + 1;
        counter.textContent = i + ' / ' + items.length;
      }, {passive:true});
    }

    function add(){
      errEl.hidden = true;
      btns.forEach(function(b){ b.setAttribute('aria-busy','true'); });
      root.setAttribute('aria-busy','true');
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {method:'POST', headers:{'Accept':'application/json'}, body:new FormData(form)})
        .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
        .then(function(){ return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }); })
        .then(function(cart){ setCount(cart.item_count); showToast(labels.added); announce(labels.added); })
        .catch(function(e){ errEl.textContent = (e && e.description) ? e.description : labels.error; errEl.hidden = false; })
        .finally(function(){ btns.forEach(function(b){ b.removeAttribute('aria-busy'); }); root.removeAttribute('aria-busy'); });
    }
    form.addEventListener('submit', function(e){ e.preventDefault(); add(); });
    var stickyBtn = root.querySelector('.bt-sticky [data-bt-add]');
    if(stickyBtn){ stickyBtn.addEventListener('click', function(){ add(); }); }

    var sticky = root.querySelector('.bt-sticky');
    var main = form.querySelector('[data-bt-add]');
    if(sticky && main){
      new IntersectionObserver(function(en){
        var below = en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', !en[0].isIntersecting && below);
        sticky.toggleAttribute('inert', !( !en[0].isIntersecting && below));
      }).observe(main);
    }
  });
})();
